import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export default () => {
  return <TableHead>
    <TableRow>
      <TableCell>ID</TableCell>
      <TableCell>CODE</TableCell>
      <TableCell>NAME</TableCell>
      <TableCell>COUNTRY</TableCell>
      <TableCell>SUBDIV</TableCell>
      <TableCell>FUNCTION</TableCell>
      <TableCell>COORDINATES</TableCell>
      <TableCell></TableCell>
    </TableRow>
  </TableHead>
}
